import { create } from 'zustand';

type TData = {
    prompt?: string | null;
    result?: string | null;
    schema?: string | null;
};

type IPromptDrawerState = {
    data?: TData;
    selectPrompt: (data?: TData) => void;
};

const initialState = {
    data: undefined
};

const usePromptDrawerStore = create<IPromptDrawerState>((set) => ({
    ...initialState,
    selectPrompt: (data) => {
        set({ data });
    }
}));

export default usePromptDrawerStore;
